import { actionTypes } from './constants';
import { TAddressDataPayload, TClubData, TClubsListData, TFindedAddresses } from './types';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const setAddresses = (addresses: TAddressDataPayload): Action<actionTypes.SET_ADDRESSES, TAddressDataPayload> => ({
    type: actionTypes.SET_ADDRESSES,
    payload: addresses
});

export const setFindedAddresses = (findedAddresses: TFindedAddresses): Action<
    actionTypes.SET_FINDED_ADDRESSES,
    TFindedAddresses
> => ({
    type: actionTypes.SET_FINDED_ADDRESSES,
    payload: findedAddresses
});

export const setIsLoadingNearestClub = (status: boolean): Action<actionTypes.SET_IS_LOADING_NEAREST_CLUBS, boolean> => ({
    type: actionTypes.SET_IS_LOADING_NEAREST_CLUBS,
    payload: status
});

export const setClubData = (data: TClubData): Action<actionTypes.SET_CLUB_DATA, TClubData> => ({
    type: actionTypes.SET_CLUB_DATA,
    payload: data
});

export const setClubsList = (data: TClubsListData[]): Action<actionTypes.SET_CLUBS_LIST, TClubsListData[]> => ({
    type: actionTypes.SET_CLUBS_LIST,
    payload: data
});

export const setGeoSearch = (data: Record<string, string[]>): Action<actionTypes.SET_GEO_SEARCH, Record<string, string[]>> => ({
    type: actionTypes.SET_GEO_SEARCH,
    payload: data
});

export const setIsClubListLoaded = (status: boolean): Action<actionTypes.SET_IS_CLUB_LIST_LOADED, boolean> => ({
    type: actionTypes.SET_IS_CLUB_LIST_LOADED,
    payload: status
});
